import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import QuestionnaireScheduleFrequencySelect from './QuestionnaireScheduleFrequencySelect';

const QuestionnaireScheduleFrequencySelectField: React.FC<
	BaseFieldProps
> = props => (
	<BaseField {...props}>
		<QuestionnaireScheduleFrequencySelect />
	</BaseField>
);

export default QuestionnaireScheduleFrequencySelectField;
